import { render, staticRenderFns } from "./DetalleTimbre.vue?vue&type=template&id=4bf1bc0e&scoped=true"
import script from "./DetalleTimbre.vue?vue&type=script&lang=js"
export * from "./DetalleTimbre.vue?vue&type=script&lang=js"
import style0 from "./DetalleTimbre.vue?vue&type=style&index=0&id=4bf1bc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf1bc0e",
  null
  
)

export default component.exports